import { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useLogin } from "../pages/contexts/LoginContext";
import ProfileMenu from "./ProfileMenu";
const NavigationComponent = () => {
  const [isNavVisible, setNavVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const overlayRef = useRef(null);
  const buttonRef = useRef(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const profileRef = useRef(null);
  const { setShowLoginModal, isLoggedIn,setIsLoggedIn, user, handleLogout } = useLogin(); // 拿登录状态和用户信息

  const navItems = [
    { name: "Home", link: "/" },
    { name: "Research", link: "/research" },
    { name: "Tips", link: "/tips" },
    { name: "CV", link: "/cv" },
  ];
  useEffect(() => {
  console.log('isLoggedIn:', isLoggedIn);
  console.log('user:', user);
}, [isLoggedIn, user]);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
  const handleClickOutside = (event) => {
    const clickedOutsideNav =
      overlayRef.current &&
      !overlayRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target);

    const clickedOutsideProfile =
      profileRef.current && !profileRef.current.contains(event.target);

    if (clickedOutsideNav) {
      setNavVisible(false);
    }

    if (clickedOutsideProfile) {
      setShowProfileMenu(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [isNavVisible]);

  const loginButtonStyle =
    "hidden md:inline-flex mr-4 px-4 py-1 rounded-md bg-gray-700 text-white hover:bg-gray-800 transition duration-200 text-sm font-medium shadow";

  return (
    <header className="flex justify-between items-center p-6 relative">
      <h1 className="text-3xl md:text-4xl font-base text-black w-full md:w-auto text-center md:text-left ml-4 md:ml-8">
        <a href="/">Heying Du</a>
      </h1>

      {/* NAV & Hamburger Container */}
      <div className="flex items-center space-x-4 relative">
        {/* Desktop Nav */}
        <ul
          className={`flex space-x-6 overflow-hidden transition-all duration-500 ease-in-out ${
            isMobile
              ? "max-w-0 opacity-0 scale-95"
              : "max-w-[300px] opacity-100 scale-100"
          }`}
        >
          {navItems.map((item) => (
            <li key={item.name} className="transition-all duration-500">
              {item.name === "CV" ? (
  <span className="text-gray-400 cursor-not-allowed">{item.name}</span>
) : (
  <NavLink
    to={item.link}
    className={({ isActive }) =>
      isActive
        ? "font-bold text-black border-b-2 border-black"
        : "text-gray-600 hover:text-gray-900"
    }
  >
    {item.name}
  </NavLink>
)}
            </li>
          ))}

          {/* 登录按钮或头像，跟 navItems 同级，左对齐 */}
          
        </ul>
{/* <li className="transition-all duration-500"> */}
            {isLoggedIn && user?.avatarUrl ? (
  <div className="relative" ref={profileRef}>
    <button
      onClick={() => {
        setNavVisible(false);
        setShowProfileMenu((prev) => !prev);
      }}
      className="rounded-full overflow-hidden border-2 border-gray-700 w-8 h-8"
      title={user?.name || "User"}
    >
      <img
        src={user.avatarUrl}
        alt="User avatar"
        className="w-full h-full object-cover"
      />
    </button>

    {showProfileMenu && (
      <ProfileMenu user={user} onClose={() => setShowProfileMenu(false)} handleLogout={handleLogout} 
  isLoggingOut={isLoggingOut}
  setIsLoggingOut={setIsLoggingOut} 
  isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}/>
    )}
  </div>
) : (
  <button
    onClick={() => setShowLoginModal(true)}
    className={loginButtonStyle}
  >
    Login
  </button>
)}
          {/* </li> */}
        {/* Hamburger Button */}
        <button
          ref={buttonRef}
          onClick={() => setNavVisible(!isNavVisible)}
          className={`md:hidden transition-all duration-500 ease-in-out ${
            isMobile ? "opacity-100 scale-100" : "opacity-0 scale-50 pointer-events-none"
          }`}
        >
          <span className="text-3xl">&#9776;</span>
        </button>
      </div>

      {/* Mobile Overlay Nav */}
      <div
        ref={overlayRef}
        className={`absolute top-full left-0 w-full origin-top transform transition-all duration-500 ease-out 
          backdrop-blur-xl bg-white/50 shadow-xl md:hidden z-40
          ${
            isNavVisible
              ? "opacity-100 scale-y-100 pointer-events-auto"
              : "opacity-0 scale-y-0 pointer-events-none"
          }`}
      >
        <ul className="flex flex-col space-y-2 p-4">
          {navItems.map((item, index) => (
            <li
              key={item.name}
              className={`rounded-md hover:bg-white/5 px-2 transition-all duration-500 ease-out
                ${
                  isNavVisible
                    ? `opacity-100 translate-y-0 delay-[${200 + index * 100}ms]`
                    : "opacity-0 translate-y-4 delay-0"
                }`}
              style={{ transitionDelay: isNavVisible ? `${200 + index * 100}ms` : "0ms" }}
            >
              {item.name === "CV" ? (
  <span className="text-gray-400 cursor-not-allowed">{item.name}</span>
) : (
  <NavLink
    to={item.link}
    className={({ isActive }) =>
      isActive
        ? "font-bold text-black border-b-2 border-black"
        : "text-gray-600 hover:text-gray-900"
    }
  >
    {item.name}
  </NavLink>
)}
            </li>
          ))}

          {/* 移动端登录按钮或头像 */}
          <li>
            {isLoggedIn && user?.avatarUrl ? (
              <button
                onClick={() => {
                  setNavVisible(false);
                }}
                className="hidden md:inline-flex rounded-full overflow-hidden border-2 border-gray-700 w-8 h-8"
                title={user?.name || "User"}
              >
                <img
                  src={user.avatarUrl}
                  alt="User avatar"
                  className="w-full h-full object-cover"
                />
              </button>
            ) : (
              <button
                onClick={() => {
                  setShowLoginModal(true);
                  setNavVisible(false);
                }}
                className="px-4 py-1 rounded-md bg-gray-700 text-white hover:bg-gray-800 transition duration-200 text-sm font-medium shadow"
              >
                Login
              </button>
            )}
          </li>
        </ul>
      </div>
    </header>
  );
};

export default NavigationComponent;